import LoaderGradient, {
    LOADER_GREY_GRADIENT_ID,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

import { StyledLoaderOverlay } from "./styles";

export const AIAgentEmailBodyEditorLoader = () => {
    return (
        <StyledLoaderOverlay>
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={14}
                width={104}
            />
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={14}
                width={412}
            />
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={14}
                width={412}
            />
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={199}
                width={275}
            />
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={14}
                width={412}
            />
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={14}
                width={188}
            />
            <LoaderGradient
                id={LOADER_GREY_GRADIENT_ID}
                height={14}
                width={124}
            />
        </StyledLoaderOverlay>
    );
};
